export default __webpack_public_path__ + "static/media/ic_bar_left_customer.4b19d2a2.svg";